import {
  useState,
  createContext,
  useContext,
  useMemo,
  useCallback,
} from 'react';
import { IValidateContactEmailCamelCase } from '../../../../services/client/types';

interface IFormProvider {
  children: JSX.Element;
  initialValues?: any;
}

export const FormContext = createContext<any>({});

export const FormProvider = ({
  children,
  initialValues = {} as any,
}: IFormProvider) => {
  const [data, setData] = useState(initialValues);
  const [contactDB, setContactDB] = useState<
    IValidateContactEmailCamelCase[] | undefined
  >(undefined);

  const setFormValues = (values: any) => {
    setData((prevValues: any) => ({
      ...prevValues,
      ...values,
    }));
  };

  const setContactDbValues = (
    values: IValidateContactEmailCamelCase[] | undefined
  ) => {
    setContactDB(values);
  };

  const clearFormValues = useCallback(() => {
    setData(initialValues);
  }, [initialValues]);

  const value = useMemo(
    () => ({
      data,
      contactDB,
      setFormValues,
      setContactDbValues,
      clearFormValues,
    }),
    [data, contactDB, clearFormValues]
  );

  return <FormContext.Provider value={value}>{children}</FormContext.Provider>;
};

export const useFormData = () => useContext(FormContext);
